// extracted by mini-css-extract-plugin
export var fullScreenBackground = "styles-module--fullScreenBackground--afd49";
export var gradient1 = "styles-module--gradient1--a651a";
export var gradient2 = "styles-module--gradient2--72682";
export var gradient3 = "styles-module--gradient3--a5d17";
export var gradientWrapper = "styles-module--gradientWrapper--c825e";
export var moveLeftAndUp = "styles-module--moveLeftAndUp--6a21a";
export var moveRightAndUp = "styles-module--moveRightAndUp--937a0";